import { render } from "./Section-2.vue?vue&type=template&id=78128cd4&scoped=true"
import script from "./Section-2.vue?vue&type=script&lang=js"
export * from "./Section-2.vue?vue&type=script&lang=js"

import "./Section-2.vue?vue&type=style&index=0&id=78128cd4&scoped=true&lang=css"

import exportComponent from "C:\\Spinnov\\ace-challenge-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78128cd4"]])

export default __exports__